import React, { useState } from "react";
import "./ClaimContactUs.css";

import contactus_layout from "../../assets/img/claims/contactus_layout.svg";

// const tabs = ["Florida", "Georgia", "Texas"];
const tabs = ["Florida", "Texas"];

const ClaimContactUs = ({ responsiveStatus }) => {
  const [selectedState, setSelectedState] = useState("Florida");

  return (
    <>
      {/* <div className="" style={styles.container}> */}

      <div className="contact-us-container1" style={styles.container}>
        <h2
          className={`${
            responsiveStatus === "isDesktop"
              ? "contact-title"
              : responsiveStatus === "isTablet" ||
                responsiveStatus === "isTabletLandscape"
              ? "contact-title"
              : "contact-title-m"
          }`}
        >
          Contact Us
        </h2>

        <div className="tab-container">
          <div
            style={{
              backgroundColor: "#ffffff80",
              width: "auto",
              display: "flex",
              justifyContent: "center",
              gap: "1rem",
            }}
          >
            {tabs.map((tab) => (
              <button
                key={tab}
                className={` ${
                  responsiveStatus === "isDesktop"
                    ? "tab"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "tab"
                    : "tab-m"
                } ${selectedState === tab ? "active" : ""}`}
                onClick={() => setSelectedState(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {selectedState === "Florida" && (
          <div className="cards-container">
            {/* Policy Card */}
            <div className={`${
                      responsiveStatus === "isDesktop"
                        ? "row"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "row-m"
                        : "head-m"
                    }`}>
              <div className="col-md-3 col-12">
                <div className="card card-p">
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Policy
                  </p>
                  <div className="row">
                    <div style={{ padding: "10px" }}>
                      <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                        <p
                          className={`${
                            responsiveStatus === "isDesktop"
                              ? "head"
                              : responsiveStatus === "isTablet" ||
                                responsiveStatus === "isTabletLandscape"
                              ? "head"
                              : "head-m"
                          }`}
                          style={{ marginBottom: "10px" }}
                        >
                          Customer Service
                        </p>
                      </div>
                      <ul>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/calendar_month.svg`)}
                            className="img_icon"
                            alt="calendar_month"
                          />{" "}
                          <span className="li_text">Monday - Friday</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/avg_pace.svg`)}
                            className="img_icon"
                            alt="Avg pace icon"
                          />{" "}
                          <span className="li_text">8:00am - 6:00pm</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/call_I.svg`)}
                            className="img_icon"
                            alt="call-icon"
                          />{" "}
                          <span className="li_text">
                            <a href="tel:3059405022">(305) 940-5022</a>
                          </span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/local_post_office.svg`)}
                            className="img_icon"
                            alt="P.O Box Icon"
                          />{" "}
                          <span className="li_text">P.O 694140</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/location_on.svg`)}
                            className="img_icon"
                            alt="location_icon"
                          />{" "}
                          <span className="li_text">Miami, FL 33269</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-9 col-12">
                <div
                  className={`card ${
                    responsiveStatus === "isDesktop"
                      ? "card-p"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "card-p"
                      : "card-p-m"
                  }`}
                  style={{
                    maxWidth: "955px",
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "325px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Claims
                  </p>
                  <div
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "row"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "row-m"
                        : "row-m"
                    }`}
                  >
                    <div
                      className="col-md-6 col-12"
                      style={{ display: "block", top: 0, marginTop: 0 }}
                    >
                      <div style={{ padding: "10px" }}>
                        <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                          <p
                            className={`${
                              responsiveStatus === "isDesktop"
                                ? "head"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "head"
                                : "head-m"
                            }`}
                            style={{ marginBottom: "10px" }}
                          >
                            Office Hours
                          </p>
                        </div>
                        <ul>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/calendar_month.svg`)}
                              className="img_icon"
                              alt="calendar_month"
                            />{" "}
                            <span className="li_text">Monday - Friday</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/avg_pace.svg`)}
                              className="img_icon"
                              alt="Avg pace icon"
                            />{" "}
                            <span className="li_text">8:00am - 5:00pm</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div style={{ padding: "10px" }}>
                        <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                          <p
                            className={`${
                              responsiveStatus === "isDesktop"
                                ? "head"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "head"
                                : "head-m"
                            }`}
                            style={{ marginBottom: "10px" }}
                          >
                            New Claims Report
                          </p>
                        </div>
                        <ul>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/calendar_month.svg`)}
                              className="img_icon"
                              alt="calendar_month"
                            />{" "}
                            <span className="li_text">Monday - Friday</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/avg_pace.svg`)}
                              className="img_icon"
                              alt="Avg pace icon"
                            />{" "}
                            <span className="li_text">8:00am - 6:00pm EST</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/call_I.svg`)}
                              className="img_icon"
                              alt="call-icon"
                            />{" "}
                            <span className="li_text">
                              <a href="tel:8003442150">(800) 344-2150</a>
                            </span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/local_post_office.svg`)}
                              className="img_icon"
                              alt="P.O Box Icon"
                            />{" "}
                            <span className="li_text">P.O 694120</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/location_on.svg`)}
                              className="img_icon"
                              alt="location_icon"
                            />{" "}
                            <span className="li_text">
                              Miami, FL 33269-1120
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${
                responsiveStatus === "isDesktop"
                  ? "row"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "row-m"
                  : "row-m"
              }`}
            >
              <div className="col-md-3 col-12">
                <div className="card card-p">
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Agent Support and Marketing
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">Monday - Friday</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">8:00am - 6:00pm</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8333658242">(833) 365-8242</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-12">
                <div
                  className="card card-p"
                  style={{
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "220px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    New Customers
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">Monday - Friday</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">8:00am - 6:00pm</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8338944678">(833) 894-4678</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`col-12 ${
                  responsiveStatus === "isDesktop"
                    ? "col-md-6 padd-left"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "col-md-6 padd-left"
                    : "col-md-6 padd-left"
                }`}
              >
                <div
                  className="card card-p"
                  style={{
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "220px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Automated Policy Status and Payments
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">7 Days a Week</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">24 Hours a Day</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8889878242">(888) 987-8242</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {selectedState === "Georgia" && (
          <div className="cards-container">
            {/* Policy Card */}
            <div className={`${
                      responsiveStatus === "isDesktop"
                        ? "row"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "row-m"
                        : "head-m"
                    }`}>
              <div className="col-md-3 col-12">
                <div className="card card-p">
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Policy
                  </p>
                  <div className="row">
                    <div style={{ padding: "10px" }}>
                      <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                        <p
                          className={`${
                            responsiveStatus === "isDesktop"
                              ? "head"
                              : responsiveStatus === "isTablet" ||
                                responsiveStatus === "isTabletLandscape"
                              ? "head"
                              : "head-m"
                          }`}
                          style={{ marginBottom: "10px" }}
                        >
                          Customer Service
                        </p>
                      </div>
                      <ul>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/calendar_month.svg`)}
                            className="img_icon"
                            alt="calendar_month"
                          />{" "}
                          <span className="li_text">Monday - Friday</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/avg_pace.svg`)}
                            className="img_icon"
                            alt="Avg pace icon"
                          />{" "}
                          <span className="li_text">8:00am - 5:00pm</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/call_I.svg`)}
                            className="img_icon"
                            alt="call-icon"
                          />{" "}
                          <span className="li_text">
                            <a href="tel:7702099710">(770) 209-9710</a>
                          </span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/local_post_office.svg`)}
                            className="img_icon"
                            alt="P.O Box Icon"
                          />{" "}
                          <span className="li_text">P.O 694140</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/location_on.svg`)}
                            className="img_icon"
                            alt="location_icon"
                          />{" "}
                          <span className="li_text">Miami, FL 33269</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-9 col-12">
                <div
                  className="card card-p"
                  style={{
                    maxWidth: "955px",
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "325px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Claims
                  </p>
                  <div
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "row"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "row"
                        : "row-m"
                    }`}
                  >
                    <div
                      className="col-md-6 col-12"
                      style={{ display: "block", top: 0, marginTop: 0 }}
                    >
                      <div style={{ padding: "10px" }}>
                        <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                          <p
                            className={`${
                              responsiveStatus === "isDesktop"
                                ? "head"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "head"
                                : "head-m"
                            }`}
                            style={{ marginBottom: "10px" }}
                          >
                            Office Hours
                          </p>
                        </div>
                        <ul>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/calendar_month.svg`)}
                              className="img_icon"
                              alt="calendar_month"
                            />{" "}
                            <span className="li_text">Monday - Friday</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/avg_pace.svg`)}
                              className="img_icon"
                              alt="Avg pace icon"
                            />{" "}
                            <span className="li_text">8:00am - 5:00pm</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div style={{ padding: "10px" }}>
                        <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                          <p
                            className={`${
                              responsiveStatus === "isDesktop"
                                ? "head"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "head"
                                : "head-m"
                            }`}
                            style={{ marginBottom: "10px" }}
                          >
                            New Claims Report
                          </p>
                        </div>
                        <ul>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/calendar_month.svg`)}
                              className="img_icon"
                              alt="calendar_month"
                            />{" "}
                            <span className="li_text">Monday - Friday</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/avg_pace.svg`)}
                              className="img_icon"
                              alt="Avg pace icon"
                            />{" "}
                            <span className="li_text">8:00am - 6:00pm EST</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/call_I.svg`)}
                              className="img_icon"
                              alt="call-icon"
                            />{" "}
                            <span className="li_text">
                              <a href="tel:7702099710">(770) 209-9710</a>
                            </span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/local_post_office.svg`)}
                              className="img_icon"
                              alt="P.O Box Icon"
                            />{" "}
                            <span className="li_text">P.O 694120</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/location_on.svg`)}
                              className="img_icon"
                              alt="location_icon"
                            />{" "}
                            <span className="li_text">
                              Miami, FL 33269-1120
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${
                responsiveStatus === "isDesktop"
                  ? "row"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "row"
                  : "row"
              }`}
            >
              <div className="col-md-3 col-12">
                <div className="card card-p">
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Agent Support and Marketing
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">Monday - Friday</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">8:30am - 5:30pm</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8333658242">(833) 365-8242</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-12">
                <div
                  className="card card-p"
                  style={{
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "220px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    New Customers
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">Monday - Friday</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">8:00am - 5:30pm</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8338944678">(833) 894-4678</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`col-12 ${
                  responsiveStatus === "isDesktop"
                    ? "col-md-6 padd-left"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "col-md-6 padd-left"
                    : "col-md-6 padd-left"
                }`}
              >
                <div
                  className="card card-p"
                  style={{
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "220px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Automated Policy Status and Payments
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">7 Days a Week </span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">24 Hours a Day</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8889878242">(888) 987-8242</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {selectedState === "Texas" && (
          <div className="cards-container">
            {/* Policy Card */}
            <div className={`${
                      responsiveStatus === "isDesktop"
                        ? "row"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "row-m"
                        : "head-m"
                    }`}>
              <div className="col-md-3 col-12">
                <div className="card card-p">
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Policy
                  </p>
                  <div className="row">
                    <div style={{ padding: "10px" }}>
                      <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                        <p
                          className={`${
                            responsiveStatus === "isDesktop"
                              ? "head"
                              : responsiveStatus === "isTablet" ||
                                responsiveStatus === "isTabletLandscape"
                              ? "head"
                              : "head-m"
                          }`}
                          style={{ marginBottom: "10px" }}
                        >
                          Customer Service
                        </p>
                      </div>
                      <ul>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/calendar_month.svg`)}
                            className="img_icon"
                            alt="calendar_month"
                          />{" "}
                          <span className="li_text">Monday - Friday</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/avg_pace.svg`)}
                            className="img_icon"
                            alt="Avg pace icon"
                          />{" "}
                          <span className="li_text">8:30am - 6:00pm</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/call_I.svg`)}
                            className="img_icon"
                            alt="call-icon"
                          />{" "}
                          <span className="li_text">
                            <a href="tel:8662230668">(866) 223-0668</a>
                          </span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/local_post_office.svg`)}
                            className="img_icon"
                            alt="P.O Box Icon"
                          />{" "}
                          <span className="li_text">P.O 694140</span>
                        </li>
                        <li>
                          <img
                            src={require(`../../assets/img/claims/location_on.svg`)}
                            className="img_icon"
                            alt="location_icon"
                          />{" "}
                          <span className="li_text">Miami, FL 33269</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-9 col-12">
                <div
                  className={`card ${
                    responsiveStatus === "isDesktop"
                      ? "card-p"
                      : responsiveStatus === "isTablet" ||
                        responsiveStatus === "isTabletLandscape"
                      ? "card-p"
                      : "card-p-m"
                  }`}
                  style={{
                    maxWidth: "955px",
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "325px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Claims
                  </p>
                  <div
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "row"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "row-m"
                        : "row-m"
                    }`}
                  >
                    <div
                      className="col-md-6 col-12"
                      style={{ display: "block", top: 0, marginTop: 0 }}
                    >
                      <div style={{ padding: "10px" }}>
                        <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                          <p
                            className={`${
                              responsiveStatus === "isDesktop"
                                ? "head"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "head"
                                : "head-m"
                            }`}
                            style={{ marginBottom: "10px" }}
                          >
                            Office Hours
                          </p>
                        </div>
                        <ul>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/calendar_month.svg`)}
                              className="img_icon"
                              alt="calendar_month"
                            />{" "}
                            <span className="li_text">Monday - Friday</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/avg_pace.svg`)}
                              className="img_icon"
                              alt="Avg pace icon"
                            />{" "}
                            <span className="li_text">8:00am - 5:00pm</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div style={{ padding: "10px" }}>
                        <div style={{ borderBottom: "1px solid #E5E4E5" }}>
                          <p
                            className={`${
                              responsiveStatus === "isDesktop"
                                ? "head"
                                : responsiveStatus === "isTablet" ||
                                  responsiveStatus === "isTabletLandscape"
                                ? "head"
                                : "head-m"
                            }`}
                            style={{ marginBottom: "10px" }}
                          >
                            New Claims Report
                          </p>
                        </div>
                        <ul>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/calendar_month.svg`)}
                              className="img_icon"
                              alt="calendar_month"
                            />{" "}
                            <span className="li_text">Monday - Friday</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/avg_pace.svg`)}
                              className="img_icon"
                              alt="Avg pace icon"
                            />{" "}
                            <span className="li_text">8:00am - 6:00pm EST</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/call_I.svg`)}
                              className="img_icon"
                              alt="call-icon"
                            />{" "}
                            <span className="li_text">
                              <a href="tel:8004508247">(800) 450-8247</a>
                            </span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/local_post_office.svg`)}
                              className="img_icon"
                              alt="P.O Box Icon"
                            />{" "}
                            <span className="li_text">P.O 694120</span>
                          </li>
                          <li>
                            <img
                              src={require(`../../assets/img/claims/location_on.svg`)}
                              className="img_icon"
                              alt="location_icon"
                            />{" "}
                            <span className="li_text">
                              Miami, FL 33269-1120
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${
                responsiveStatus === "isDesktop"
                  ? "row"
                  : responsiveStatus === "isTablet" ||
                    responsiveStatus === "isTabletLandscape"
                  ? "row-m"
                  : "row"
              }`}
            >
              <div className="col-md-3 col-12">
                <div className="card card-p">
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Agent Support and Marketing
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">Monday - Friday</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">8:00am - 6:00pm</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8333658242">(833) 365-8242</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-12">
                <div
                  className="card card-p"
                  style={{
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "220px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    New Customers
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">Monday - Friday</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">8:00am - 4:30pm</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8338944678">(833) 894-4678</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`col-12 ${
                  responsiveStatus === "isDesktop"
                    ? "col-md-6 padd-left"
                    : responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                    ? "col-md-6 padd-left"
                    : "col-md-6 padd-left"
                }`}
              >
                <div
                  className="card card-p"
                  style={{
                    minHeight:
                      responsiveStatus === "isTablet" ||
                      responsiveStatus === "isTabletLandscape"
                        ? "220px"
                        : "",
                  }}
                >
                  <p
                    className={`${
                      responsiveStatus === "isDesktop"
                        ? "head"
                        : responsiveStatus === "isTablet" ||
                          responsiveStatus === "isTabletLandscape"
                        ? "head"
                        : "head-m"
                    }`}
                  >
                    Automated Policy Status and Payments
                  </p>
                  <div style={{ padding: "10px" }}>
                    {/* <div style={{borderBottom: '1px solid #E5E4E5',}}>
          <p style={{fontWeight: 600, fontSize: '20px', lineHeight:'100%', color: '#000',
            marginBottom: '10px'
          }}>Customer Service</p>
          </div> */}
                    <ul>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/calendar_month.svg`)}
                          className="img_icon"
                          alt="calendar_month"
                        />{" "}
                        <span className="li_text">7 Days a Week </span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/avg_pace.svg`)}
                          className="img_icon"
                          alt="Avg pace icon"
                        />{" "}
                        <span className="li_text">24 Hours a Day</span>
                      </li>
                      <li>
                        <img
                          src={require(`../../assets/img/claims/call_I.svg`)}
                          className="img_icon"
                          alt="call-icon"
                        />{" "}
                        <span className="li_text">
                          <a href="tel:8889878242">(888) 987-8242</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* </div> */}
    </>
  );
};

const styles = {
  container: {
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${contactus_layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

export default ClaimContactUs;
